import React from "react";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles(() => ({
  root: {
    height: "102px",
    backgroundColor: "#F8F8F8",
    width: "100%",
    filter: "grayscale(1)",
  },
}));

export const FooterReset = () => {
  const classes = useStyles();
  return <div className={classes.root}></div>;
};
